// extracted by mini-css-extract-plugin
module.exports = {"cover":"privacyPolicy_cover__xXLQf","title":"privacyPolicy_title__2T-J4"};